export enum SubscribingStatus {
  NotFound = 'notFound',
  Subscribed = 'subscribed',
  Unsubscribed = 'unsubscribed',
}
